import SxDef from '@core/types/SxDef';

const useSx = (): SxDef => ({
  root: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    justifyContent: { xs: 'center', md: 'flex-end' },
    gap: '10px',
    '.userInput-Root': {
      width: { xs: '100%', md: '200px' },
    },
  },
});

export default useSx;
